import { Box, Container, Stack, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import { useState } from "react";
import Description from "./Description";
import Reviews from "./Reviews";
import Specification from "./Specification";
import { useSelector } from "react-redux";

const InfoTabs = ({ packageDetail }) => {
  const { palette } = useTheme();
  const [activeTab, setActiveTab] = useState("description");
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const tabs = ["specification", "description", "reviews"];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <Container
      maxWidth={"md"}
      sx={{
        maxWidth: "1000px !important",
        border: `1px solid ${palette.text.coolGrey} `,
        my: 3,
      }}
    >
      <Stack mt={2} direction={"row"} justifyContent={"space-around"}>
        {tabs.map((tab) => (
          
          <Box
            key={tab}
            onClick={() => handleTabClick(tab)}
            sx={{
              cursor: "pointer",
              position: "relative",
              paddingBottom: "8px",
              "&:hover": { color: "grey" },
            }}
          >
            <Typography
              variant="h6"
              fontWeight={600}
              color={activeTab === tab ? "text.black" : "inherit"}
              textTransform={"capitalize"}
            >
              {t(tab)}
            </Typography>
            {activeTab === tab && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: "2px",
                  backgroundColor: "text.orangeRed",
                }}
              />
            )}
          </Box>
        ))}
      </Stack>

      <Box>
        {activeTab === "specification" ? (
          <Specification specification={packageDetail?.specification} />
        ) : activeTab === "description" &&
          packageDetail?.description[currentLanguage] ? (
          <Description description={packageDetail?.description} />
        ) : (
          <Reviews reviews={[]} />
        )}
      </Box>
    </Container>
  );
};

export default InfoTabs;
